import React, { Component } from "react";
import { Segment, Confirm, Message, Modal, Button, Header } from "semantic-ui-react";

import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import AddPrize from "./AddPrize";
import WinnersTable from "../../components/tables/WinnersTable";
import PickWinner from "./PickWinner";
import ManualCTACardSelection from '../../components/forms/winners/ManualCTACardSelection';

const resetState = (props) => {
    return {
        isLoading: false,
        event: false,
        winners: [],
        winnersFiltered: [],
        prizeOptions: [],
        summary: [],
        devices: [],
        confirmOpen: false,
        confirmId: 0,
        confirmTitle: "",
        xhrStatus: null,
        xhrMessage: null,
        pollInterval: false,
        showMessage: true
    }
  }

class WinnersTab extends Component {
  constructor(props) {
    super(props);
    this.state = resetState(props);
  }

  startLoading = () => {
    this.setState({ isLoading: true });
  }

  stopLoading = () => {
    this.setState({ isLoading: false });
  }

  resetXhrResponse = () => {
    this.setState({ xhrStatus: null, xhrMessage: null });
  }

  async componentDidMount () {
    const { eventId } = this.props;
    this.startLoading();
    this.init();
    let summary = await request.get(this, `api:/event/${eventId}/summary`, { ts: Date.now() });
    let devices = await request.get(this, `api:/event/${eventId}/devices`, { eventId: eventId, ts: Date.now() });
    this.setState({ summary: summary, devices: devices });
    this.resetXhrResponse(); // reset xhr response
  };

  componentWillUnmount = () => {
    clearInterval(this.state.pollInterval);
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  init = async () => {
    if (this.props.eventId === 0) return false;

    this.fetchPrizes();
    this.fetchDraws();
    this.fetchEvent();
  };

  fetchPrizes = async() => { // fetch all undrawn prizes for the event
    let prizes = await request.get(this, `api:/event/${this.props.eventId}/winners/new`, {sorted: [{id: 'is_grand', desc: false}, {id: 'draw_at', desc: false}]});
    this.setPrizes(prizes);
  }

  setPrizes = prizes => {
    let prizeList = [];
    prizes && prizes.length > 0 && prizes.map(prize => {
        prizeList.push({
          id: prize.id,
          value: prize.id,
          text: prize.title,
          gameid: prize.game_id,
          drawat: prize.draw_at,
          isgrand: prize.is_grand,
          issecondary: prize.is_secondary,
          criteria: prize.criteria,
          prizegroupid: prize.prize_group_id,
          prizeid: prize.prize_id
        });
      return prize;
    });

    this.setState({ prizeOptions: prizeList });
  };

  fetchDraws = async() => { // fetch all draws from event
    clearInterval(this.state.pollInterval);
    let winnerPayload = {
        limit: 0,
        page: 1,
        sorted: [],
        ts: Date.now()
    };
    let winners = await request.get(this, `api:/event/${this.props.eventId}/winners`, winnerPayload); // all draws
    this.setWinners(winners);
  }

  setWinners = result => {
    this.setState({ isLoading: true });
    let winnersList = [];
    let winnersFilteredList = [];
    let ctaGrandDraw = null;
    result && result.data && result.data.map((value, index) => {
      if (value.prize_group_id != 0 && value.prize_id == 0) {
        winnersList.push(value);
      } else if (value.is_secondary === 1) {
        winnersList.push(value);
        winnersFilteredList.push(value);
      } else if (value.draw_at === null) {
        winnersList.push(value);
        winnersFilteredList.push(value);
      } else {
        if (!result.data.must_go && value.is_grand && value.game_id === 3 && value.status === 'complete') {
          value.prize = +value.prize + +value.jackpot;
        }
        winnersList.push(value);
        winnersFilteredList.push(value);
        ctaGrandDraw = value;
      }
      return value;
    });
    this.setState({
        winners: winnersList,
        winnersFiltered: winnersFilteredList,
        ctaGrandDraw: ctaGrandDraw,
        isLoading: false,
        pollInterval: false
    }, () => this.handlePoll());
  };

  fetchEvent = async() => {
    const { eventId } = this.props;
    let event = await request.get(this, `api:/event/${eventId}`, {});
    this.setState({ event: event }, () => this.stopLoading());
  }

  handlePoll = () => {
    if (!this.state.pollInterval) {
      let poll = setInterval(this.fetchDraws, 15000);
      this.setState({
        pollInterval: poll
      });
    }
  };

  showConfirm = (id, title) => {
    this.setState({ confirmOpen: true, confirmId: id, confirmTitle: title });
  };

  handleCancel = () => {
    this.setState({
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
  };

  deleteSecondaryPrize = () => {
    this.handleCancel(); // close the confirm dialog
    this.startLoading();

    const { eventId } = this.props;
    const { confirmId } = this.state;

    return request.delete(this, `api:/event/${eventId}/secondary-draw/${confirmId}`).then(resp => {
      this.setState({
        isLoading: false,
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message
      }, () => this.init());
    });
  };

  handleXhrData = (xhrStatus, xhrMessage) => {
    this.setState({ xhrStatus, xhrMessage });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.xhrStatus === "success" && prevState.xhrStatus !== "success") {
      setTimeout(() => {
        this.setState({showMessage: false});
      }, 5000);
    }
  };

  handleTransitionEnd = () => {
    this.setState({showMessage: true, xhrStatus: null, xhrMessage: null});
  };

  render() {
    const { winners,
        winnersFiltered,
        ctaGrandDraw,
        prizeOptions,
        event,
        summary,
        devices,
        confirmOpen,
        confirmTitle,
        isLoading,
        xhrStatus,
        xhrMessage,
        showMessage } = this.state;

    const { settings, config } = this.context;

    let disableRNGPickWinnerBtn = false; // rng pick winner btn flag
    let disableBEPPickWinnerBtn = false; // bep pick winner btn flag
    let warningMsg = "";

    // check for conditions to determine rng/bep pick winner btn to be disabled or not
    if (prizeOptions?.length === 0) {
      disableRNGPickWinnerBtn = true;
      disableBEPPickWinnerBtn = true;
    }

    // check to disable rng and bep pick winner btns if no sales found or other errors
    if (summary && summary.sets && (summary.sets.net === 0)) {
      warningMsg = "No sales found for this event!";
      disableRNGPickWinnerBtn = true;
      disableBEPPickWinnerBtn = true;
    } else if (summary && summary.printer_queue && (summary.printer_queue != 0)) {
      warningMsg = "Please wait for all print jobs to complete. Print Queue: " + summary.printer_queue;
      disableBEPPickWinnerBtn = true;
    } else if (this.state.warningMsg) {
      warningMsg = this.state.warningMsg;
      disableRNGPickWinnerBtn = true;
      disableBEPPickWinnerBtn = true;
    }

    return (
      <Segment basic>
        {xhrStatus === "success" &&
        <Message
          success
          content={xhrMessage}
          style={{ opacity: showMessage ? 1 : 0, transition: "opacity 0.5s ease-in-out"}} 
          onTransitionEnd={this.handleTransitionEnd} 
        />}
        {xhrStatus === "error" && <Message error content={xhrMessage} />}
        <Segment basic textAlign="right">
            {config.secondary_draws_enabled === true && (
                <Modal
                    trigger={<Button primary>Add a Prize</Button>}
                    closeIcon
                    onClose={this.resetXhrResponse}
                    size="small"
                >
                    <Header icon='suitcase' content='Add Secondary Prize' />
                    <Modal.Content>
                        <AddPrize eventId={this.props.eventId} event={this.state.event} mode="create" fetchDraws={this.fetchDraws} />
                    </Modal.Content>
                </Modal>
            )}
            <PickWinner
                parentLoading={isLoading}
                eventId={this.props.eventId}
                winners={winners}
                prizeOptions={prizeOptions}
                devices={devices}
                init={this.init}
                event={event}
                warningMsg={warningMsg}
                disableRNGPickWinnerBtn={disableRNGPickWinnerBtn}
                disableBEPPickWinnerBtn={disableBEPPickWinnerBtn}
                ctaCardType={config.option_card_type}
                fetchDraws={this.fetchDraws}
                fetchPrizes={this.fetchPrizes}
            />
            {config.option_card_type === "physical" &&
            ctaGrandDraw?.number &&
            ctaGrandDraw?.card?.suit === "" &&
                <ManualCTACardSelection
                    event={event}
                    init={this.init}
                    eventId={this.props.eventId}
                    cardSetId={this.props.cardSetId}
                    disableManualSelection={ctaGrandDraw?.card?.suit !== ""}
                />
            }
        </Segment>
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.deleteSecondaryPrize}
        />
        <WinnersTable
          winners={winnersFiltered}
          event={event}
          eventId={this.props.eventId}
          isLoading={isLoading}
          ctaCardType={config.option_card_type}
          manualCtaRedrawEnabled={config.manual_cta_redraw_enabled}
          init={this.init}
          fetchDraws={this.fetchDraws}
          showConfirm={this.showConfirm}
          fetchXhr={this.handleXhrData}
        />
      </Segment>
    );
  }
}

WinnersTab.contextType = AppContext;

export default WinnersTab;
